/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";

export interface IInventoryDetailMethods extends IPluginMethodMap {
  getInventoryDetailProps(args: any): Promise<any>;
}

export class InventoryDetailService implements IAgentPlugin {
  readonly methods: IInventoryDetailMethods;

  constructor() {
    this.methods = {
      getInventoryDetailProps: this.getInventoryDetailProps.bind(this),
    };
  }

  async getInventoryDetailProps(args: any) {
    try {
      const sections = [
        "Adelita", "Amirah", "Bahia", "Bella", "Carnival Soul",
        "D'Aura", "Dharhan", "Elektra", "Flair", "GenX"
      ];

      const inventoryData = sections.map((sec, idx) => {
        const base = 10 + idx * 5;
        const row: any = {
          id: String(idx + 1),
          section: sec,
          male: base + 20,
          backline: base + 45,
          femaleOption2: base + 12,
          sectionLeader: base + 2,
          female: base + 80,
          individual: base,
          femaleOption1: base + 8,
          frontline: base + 30,
          myMondayPackage: base + 5,
          individualHeadFee: base + 1,
          booking: base + 4,
        };
        row.total = row.male + row.backline + row.femaleOption2 + row.sectionLeader +
                    row.female + row.individual + row.femaleOption1 + row.frontline +
                    row.myMondayPackage + row.individualHeadFee + row.booking;
        return row;
      });

      const registeredData = sections.map((sec, idx) => {
        const base = 8 + idx * 4;
        const row: any = {
          id: String(idx + 1),
          section: sec,
          male: base + 15,
          backline: base + 38,
          femaleOption2: base + 9,
          sectionLeader: base + 1,
          female: base + 72,
          individual: base - 2 > 0 ? base - 2 : 0,
          femaleOption1: base + 6,
          frontline: base + 24,
          myMondayPackage: base + 3,
          individualHeadFee: base,
          booking: base + 2,
        };
        row.total = row.male + row.backline + row.femaleOption2 + row.sectionLeader +
                    row.female + row.individual + row.femaleOption1 + row.frontline +
                    row.myMondayPackage + row.individualHeadFee + row.booking;
        return row;
      });

      const availableData = sections.map((sec, idx) => {
        const inv = inventoryData[idx];
        const reg = registeredData[idx];
        const row: any = {
          id: String(idx + 1),
          section: sec,
          male: inv.male - reg.male,
          backline: inv.backline - reg.backline,
          femaleOption2: inv.femaleOption2 - reg.femaleOption2,
          sectionLeader: inv.sectionLeader - reg.sectionLeader,
          female: inv.female - reg.female,
          individual: inv.individual - reg.individual,
          femaleOption1: inv.femaleOption1 - reg.femaleOption1,
          frontline: inv.frontline - reg.frontline,
          myMondayPackage: inv.myMondayPackage - reg.myMondayPackage,
          individualHeadFee: inv.individualHeadFee - reg.individualHeadFee,
          booking: inv.booking - reg.booking,
        };
        row.total = row.male + row.backline + row.femaleOption2 + row.sectionLeader +
                    row.female + row.individual + row.femaleOption1 + row.frontline +
                    row.myMondayPackage + row.individualHeadFee + row.booking;
        return row;
      });

      return {
        inventoryData,
        registeredData,
        availableData,
      };
    } catch (err: any) {
      console.log(`error in getInventoryDetailProps`, err);
      return {
        inventoryData: [],
        registeredData: [],
        availableData: [],
      };
    }
  }
}
